<template>
  <v-row justify="center">
    <v-col cols="8">
      <div class="mt-1">
        <b>Categoría en mi empresa</b>
      </div>
      <div>
        <ProductoCategoriaForm
          @set_categoria="setCategoria"
          :categoria="producto.categoria"
        />
      </div>
      <div>
        <ProductoMarcaForm :outlined="true" :producto="producto" />
      </div>
      <div>
        <div class="mt-2">
          <b>Nombre del producto</b>
        </div>
        <div>
          <form-producto-descripcion :descripcion="producto.descripcion">
          </form-producto-descripcion>
          <GenericAttributeInput
            attributeName="descripcion"
            label="Descripción del producto utilizada por esta empresa"
            type="text"
            :rules="'required|max:100'"
            :value="producto.descripcion"
            :outlined="true"
            @update-attribute="(payload) => handleAttributeUpdateBase(payload)"
          />
        </div>
      </div>
      <div>
        <v-divider></v-divider>
        <div class="mt-1">
          <b>Código de barra</b>
        </div>
        <div style="font-size: 14px">
          Escanea el código de barra del producto o escríbelo manualmente.
        </div>
        <div class="mt-1">
          <form-producto-barcode :producto="producto"></form-producto-barcode>
        </div>
      </div>

      <div name="Precio de costo">
        <div>
          <b>Precio de costo</b>
        </div>

        <div class="mt-1">
          <GenericAttributeInput
            attributeName="precio_costo_base"
            label="Precio de Costo"
            type="number"
            :rules="'required|decimal:2|max:30'"
            :value="producto.precio_costo_base"
            :outlined="true"
            @update-attribute="(payload) => handleAttributeUpdateBase(payload)"
          />
        </div>
      </div>
      <div name="Ganancia">
        <v-divider></v-divider>
        <div class="mt-1">
          <b>Ganancia del producto</b>
        </div>

        <div class="mt-1">
          <GenericAttributeInput
            attributeName="margen_ganancia_sugerido"
            label="Margen de ganancia"
            type="number"
            :rules="'required|decimal:2|max:30'"
            :value="producto.margen_ganancia_sugerido"
            :outlined="true"
            @update-attribute="(payload) => handleAttributeUpdateBase(payload)"
          />
        </div>
      </div>
      <div>
        <PrecioVentaCalculatorWrapper
          :precioCosto="producto.precio_costo_base"
          :ganancia="producto.margen_ganancia_sugerido"
          :precioVenta="producto.precio_venta_sugerido"
          :esPrecioVentaManual="false"
          tipoRedondeo="entero"
          :outlined="true"
          @update:precioVenta="
            handleAttributeUpdateBase({
              name: 'precio_venta_sugerido',
              value: $event,
            })
          "
          @update:ganancia="
            handleAttributeUpdateBase({
              name: 'margen_ganancia_sugerido',
              value: $event,
            })
          "
          ref="precioVentaWrapper"
        />
      </div>
      <div>
        <v-btn :loading="loading" @click="registrarProductoEmpresa()">
          Registrar
        </v-btn>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import FormProductoDescripcion from "@/components/producto/form/form.producto.descripcion.vue";
import FormProductoBarcode from "@/components/producto/form/form.producto.barcode.vue";
import FormProductoPrecioCosto from "@/components/producto/form/form.producto.precio.costo.vue";
import FormProductoGanancia from "@/components/producto/form/form.producto.ganancia.vue";
import FormProductoFlete from "@/components/producto/form/form.producto.flete.vue";
import ProductoCategoriaForm from "@/components/producto/form/form.producto.categoria.vue";
import ProductoMarcaForm from "@/components/producto/form/form.producto.marca.vue";
import PrecioVentaCalculatorWrapper from "@/components/producto/form/PrecioVentaCalculatorWrapper.vue";

import GenericAttributeInput from "@/components/util/GenericAttributeInput.vue";

export default {
  name: "ProductoEmpresaRegistrar",
  components: {
    FormProductoDescripcion,
    FormProductoBarcode,
    FormProductoPrecioCosto,
    FormProductoGanancia,
    FormProductoFlete,
    ProductoCategoriaForm,
    ProductoMarcaForm,
    PrecioVentaCalculatorWrapper,
    GenericAttributeInput,
  },
  props: {
    productoCatalogo: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      loading: false,
      producto: {
        descripcion: "",
        precio_costo_base: null,
        precio_venta_sugerido: null,

        margen_ganancia_sugerido: null,
        marca: { id: null },
        proveedor: null,
        categoria: { id: null },
        codigoDeBarra: null,

        es_elaboracion_propia: false,
      },
    };
  },
  methods: {
    handleAttributeUpdateBase({ name, value }) {
      console.log(name, value);

      this.$set(this.producto, name, value); // Usar $set es una buena práctica si el atributo pudiera no existir inicialmente
    },
    setDescripcion(valor) {
      this.producto.descripcion = valor;
    },
    setCategoria(categoria) {
      this.producto.categoria = categoria;
    },

    registrarProductoEmpresa() {
      let producto = this.producto;
      if (this.productoCatalogo) {
        producto.producto_catalogo_id = this.productoCatalogo.id;
      }
      this.axios
        .post(`/productos/productos`, producto)
        .then((response) => {
          // this.update_product(data);
          this.$updateBus.$emit("showSnackBar", {
            show: true,
            button: false,
            color: "success",
            text: "Producto registrado",
            icon: "mdi-check",
            timeout: 3000,
          });
          this.loading = false;
          const uuid_empresa = this.$route.params.uuid_empresa;

          var producto_empresa_id = response.data.producto_empresa_id;
          this.$router.push({
            name: "productoEmpresaDetalle",
            params: {
              uuid_empresa: uuid_empresa,
              id_producto: producto_empresa_id,
            },
          });
          producto_empresa_id;

          // this.$emit("process-product-register-success");
        })
        .catch((e) => {
          this.$updateBus.$emit("showSnackBar", {
            show: true,
            button: false,
            color: "info",
            text: "Problema inesperado",
            icon: "mdi-information",
            timeout: 3000,
          });
          this.loading = false;

          // this.$router.push({
          //   name: "MensajeRegistroError",
          //   params: { error: e.response.data },
          // });
        });
    },
  },
  watch: {
    productoCatalogo: {
      handler(newVal) {
        this.producto.descripcion = newVal.descripcion;
        console.log(newVal);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
</style>